import { Controller, useFormContext } from 'react-hook-form';
import { DashboardPageFormBody, DashboardPageFormField } from '@shigo-ui/dashboard-ui';
import {
  Input,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  Textarea,
} from '@shigo-ui/ui';

import { dashboardT } from '../../../../../lib/messages';
import { PublisherStatus } from '../../model';
import type { PublisherFormValue } from '../../publisherFormSchema';

export function PublisherGeneralFields({ editing }: { editing: boolean }) {
  'use no memo';
  const { control } = useFormContext<PublisherFormValue>();
  return (
    <DashboardPageFormBody>
      <Controller
        control={control}
        name="name"
        render={({ field, fieldState }) => (
          <DashboardPageFormField
            label={dashboardT('publishers.name')}
            htmlFor="publisher-name"
            required
            error={fieldState.error?.message}
          >
            <Input
              {...field}
              id="publisher-name"
              required
              disabled={editing}
              aria-invalid={Boolean(fieldState.error)}
            />
          </DashboardPageFormField>
        )}
      />
      {editing ? (
        <Controller
          control={control}
          name="status"
          render={({ field, fieldState }) => (
            <DashboardPageFormField
              label={dashboardT('publishers.status')}
              required
              error={fieldState.error?.message}
            >
              <Select value={field.value} onValueChange={field.onChange}>
                <SelectTrigger aria-label={dashboardT('publishers.status')}>
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value={PublisherStatus.Active}>
                    {dashboardT('publishers.status.active')}
                  </SelectItem>
                  <SelectItem value={PublisherStatus.Archived}>
                    {dashboardT('publishers.status.archived')}
                  </SelectItem>
                </SelectContent>
              </Select>
            </DashboardPageFormField>
          )}
        />
      ) : null}
      <Controller
        control={control}
        name="notes"
        render={({ field, fieldState }) => (
          <DashboardPageFormField
            label={dashboardT('publishers.notes')}
            htmlFor="publisher-notes"
            error={fieldState.error?.message}
          >
            <Textarea
              {...field}
              id="publisher-notes"
              rows={5}
              aria-invalid={Boolean(fieldState.error)}
            />
          </DashboardPageFormField>
        )}
      />
    </DashboardPageFormBody>
  );
}
